import { Survey } from '@app/models/performance/survey.model';
import { BadgeColumn } from '@app/modules/table/classes/badge-column.class';
import { CheckListFilter } from '@app/modules/table/classes/column-filters/check-list/check-list-filter.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { BadgeDisplay } from '@app/modules/table/interfaces/badge-display.interface';
import {
    SurveyStatusesDisplayOptions,
    SurveyStatusesDisplayOptionsById,
} from '@app/types/translatables/survey-statuses-display.options';

export class StatusColumn extends BadgeColumn<Survey> {
    title = 'surveys.index.columnHeaders.status';
    property = 'status';
    sortField = 'statusId';
    sortable = true;
    type: CellDisplay = CellDisplay.badge;

    constructor() {
        super();

        const options = [
            {
                label: SurveyStatusesDisplayOptions.completed,
                value: 1,
            },
            {
                label: SurveyStatusesDisplayOptions.inProgress,
                value: 3,
            },
            {
                label: SurveyStatusesDisplayOptions.scheduled,
                value: 4,
            },
            {
                label: SurveyStatusesDisplayOptions.overdue,
                value: 5,
            },
            {
                label: SurveyStatusesDisplayOptions.missed,
                value: 6,
            },
        ];

        this.filter = new CheckListFilter('statusId', options, this.title);
    }

    getBadgeDisplay(survey: Survey): BadgeDisplay | undefined {
        return {
            type: survey.statusBadgeType,
            label: SurveyStatusesDisplayOptionsById[survey.statusId] ?? survey.status,
        };
    }
}
